import { useMemo } from "react";

import QUERY_TAGS from "../search/queryTags";
import useQuery from "../search/useQuery";

import { buildBoundsParams, stableKey } from "./accessoryFilters";
import { fetchPriceBounds } from "./accessoriesService";

const BOUNDS_STALE_TIME = 600000;

const usePriceBounds = ({ params, enabled = true }) => {
  const boundsParams = useMemo(() => buildBoundsParams(params), [params]);

  const key = enabled && params?.containerOptionId
    ? `accessories:bounds:${stableKey(boundsParams)}`
    : null;

  const query = useQuery({
    key,
    tag: QUERY_TAGS.PRODUCT_ACCESSORY_BOUNDS,
    fetcher: () => fetchPriceBounds(boundsParams),
    staleTime: BOUNDS_STALE_TIME,
  });

  return {
    bounds: query.currentData || null,
    isFetching: query.isFetching,
    isSuccess: query.isSuccess,
  };
};

export default usePriceBounds;
